import type { GetProductSearchParams } from "@zaprooecommerce/magento-types";
import { hash } from "ohash";
import type { Aggregation } from "~/types/catalog/Aggregation";

export function useAggregationsData(
  params: MaybeRef<GetProductSearchParams>,
  options?: { key?: string },
) {
  const { products: fetchProducts } = useMagentoSdk();

  const key =
    options?.key ?? `magento-agg-${hash(JSON.stringify(unref(params)))}`;

  const asyncData = useSyncCachedAsyncData(key, async () => {
    const res = await fetchProducts(unref(params), {
      customQuery: {
        products: "aggregations",
      },
    });

    throwGqlError(res);

    return (res.data.products as any)?.aggregations as
      | Aggregation[]
      | undefined;
  });

  const { data, pending, refresh, error } = asyncData;

  const aggregations = computed<Aggregation[]>(() => data.value ?? []);

  return {
    asyncData,
    data,
    aggregations,
    pending,
    refresh,
    error,
  };
}
